<template>
	<div>
		<div class="m-accordion m-accordion--default">
			<div class="m-accordion__item">
				<div class="m-accordion__item-head" role="tab" data-toggle="collapse" href="#m_accordion_user_info">
					<span class="m-accordion__item-icon"><i class="fa fa-user-circle"></i></span>
					<span class="m-accordion__item-title">Thông tin tài khoản</span>
					<span class="m-accordion__item-mode"></span>
				</div>
				<div class="m-accordion__item-body collapse show" id="m_accordion_user_info">
					<div class="m-accordion__item-content accordion-config">
						<div v-if="parentsCode.length == 0">
							<span class="no-parent">Không thể tạo tài khoản do chưa có cấp trên!</span>
						</div>
						<form v-else class="m-form m-form--label-align-left- m-form--state-" id="m_form">
							<div class="m-portlet__body m-portlet__body--no-padding">
								<div class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" id="m_wizard_form_step_1">
									<div class="form-group m-form__group row" v-if="this.role == 'player'">
										<label class="col-2 col-form-label">*Tên đăng nhập:</label>
										<div class="col-8 col-sm-6 col-md-4">
											<input :disabled="mode == 'edit'" v-model="partner_uname" type="text" class="form-control m-input">
										</div>
										<div class="col-2">
											<button :disabled="this.mode == 'edit'" @click.prevent="connectPlayer" class="btn btn-small btn-primary m-btn m-btn--icon">
												<span>
													<i class="la la-check"></i>
													<span>Kiểm tra</span>
												</span>
											</button>
										</div>
									</div>
									<div v-show="this.user.role != 'agency' && !(this.role == 'player' && this.mode == 'create' && this.user.role == 'agency')" class="form-group m-form__group row">
										<label v-if="this.role=='player'" class="col-2 col-form-label">*Mã tổng:</label>
										<label v-else class="col-2 col-form-label">*Mã:</label>
										<div class="col-4" v-if="this.role != 'house'">
											<select :disabled="this.mode == 'edit' || !connectSuccess" id="parentCode" class="code form-control m-select2"></select>
										</div>
										<div class="col-2" v-show="!(this.role=='player' && this.mode =='create')">
											<select :disabled="this.mode == 'edit' || !connectSuccess  || this.role == 'player'" id="codeCharacter1" class="code form-control m-select2">
												<option v-for="c in this.codeCharacters" :value="c.toLowerCase()">{{c.toUpperCase()}}</option>
											</select>
										</div>
										<div class="col-2" v-if="this.role != 'house'" v-show="!(this.role=='player' && this.mode =='create')">
											<select :disabled="this.mode == 'edit' || !connectSuccess || this.role == 'player'" id="codeCharacter2" class="code form-control m-select2">
												<option v-for="c in this.codeCharacters" :value="c.toLowerCase()">{{c.toUpperCase()}}</option>
											</select>
										</div>
										<div class="col-2" v-show="!(this.role=='player' && this.mode =='create')">
											<button class="btn btn-small btn-primary m-btn m-btn--icon" :disabled="this.mode == 'edit' || !connectSuccess" @click.prevent="checkCode" >
												<span>
													<i class="la la-check"></i>
													<span>Kiểm tra</span>
												</span>
											</button>
										</div>
									</div>
									<div class="form-group m-form__group row" v-if="connectSuccess">
										<label class="col-2 col-form-label">*Mật khẩu:</label>
										<div class="col-4">
											<input v-model="password" type="password" class="form-control m-input" placeholder="6 ký tự trở lên">
										</div>
										<label class="col-2 col-form-label">*Nhập lại mk:</label>
										<div class="col-4">
											<input v-model="confirm_password" type="password" class="form-control m-input" placeholder="6 ký tự trở lên">
										</div>
									</div>
									<div class="form-group m-form__group row" v-if="connectSuccess">
										<label class="col-2 col-form-label">*Tên:</label>
										<div class="col-4">
											<input v-model="fullName" type="text" class="form-control m-input" placeholder="Tên">
										</div>
										<label class="col-2 col-form-label">Tín dụng:</label>
										<div class="col-4">
											<div class="input-group">
												<currency-input v-model="budget"></currency-input>
											</div>
											<span class="m-form__help">Số dư {{this.remainBudget}}</span>
										</div>
									</div>
									<div class="form-group m-form__group row" v-if="this.role == 'player' && connectSuccess">
										<label class="col-2 col-form-label">* Hệ:</label>
										<div class="col-2">
											<he-selection 
												:disabled="this.mode=='edit'"
												:currentClass="this.currentClass"
												v-on:he-change="this.onHeChange"
											/>
										</div>
										<label class="col-2 col-form-label">Chạy mạng:</label>
										<div class="col-2">
											<span class="m-switch m-switch--outline m-switch--icon m-switch--success">
												<label>
							                        <input v-model="allow_bet" type="checkbox" name="">
							                        <span></span>
							                    </label>
							                </span>
										</div>
										<label class="col-2 col-form-label">Tính KI rưỡi:</label>
										<div class="col-2">
											<span class="m-switch m-switch--outline m-switch--icon m-switch--success">
												<label>
							                        <input v-model="ki" type="checkbox" name="">
							                        <span></span>
							                    </label>
							                </span>
										</div>
									</div>
									<div class="form-group m-form__group row" v-if="this.role == 'player' && connectSuccess">
										<label class="col-2 col-form-label">Gia hạn:</label>
										<div class="col-4">
											<div class="m-dropdown m-dropdown--up m-dropdown--inline m-dropdown--small m-dropdown--arrow m-dropdown--align-right" m-dropdown-toggle="hover" aria-expanded="true">
							                    <a href="javascript:;" class="m-dropdown__toggle btn btn btn-outline-primary dropdown-toggle">
							                        {{expires_opts[expires_time]}}
							                    </a>
							                    <div class="m-dropdown__wrapper" style="z-index: 101;">
							                        <span class="m-dropdown__arrow m-dropdown__arrow--right"></span>
							                        <div class="m-dropdown__inner">
							                            <div class="m-dropdown__body">              
							                                <div class="m-dropdown__content">
							                                    <ul class="m-nav">
							                                        <li v-for="(dr, key) in expires_opts" class="m-nav__item">
							                                            <a v-if="mode!='edit' || key!='trial'" @click="onExpiresChange(key)" href="javascript:;" class="m-nav__link">
							                                                <i class="m-nav__link-icon flaticon-share"></i>
							                                                <span class="m-nav__link-text">{{dr}}</span>
							                                            </a>
							                                        </li>
							                                    </ul>
							                                </div>
							                            </div>
							                        </div>
							                    </div>
							                </div>
										</div>
										<label class="col-2 col-form-label">Ngày hết hạn:</label>
										<div class="col-4">
											<input :style="expiresColor" disabled v-model="expires_at" type="text" class="form-control m-input">
										</div>
									</div>
									<div class="form-group m-form__group row" v-if="connectSuccess">
										<label class="col-2 col-form-label">Ghi chú:</label>
										<div class="col-10">
											<textarea v-model="note" type="text" class="form-control m-input" placeholder="Ghi chú"></textarea>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<account-config v-if="parentsCode.length > 0" ref="config" :uclass="this.editUserClass" :mode="this.mode" :role="this.role"></account-config>
		<a href="javascript:;" @click="this.createAccount" style="float:right; margin-right: 25px;" class="btn btn-success m-btn m-btn--custom m-btn--icon">
			<span>
				<span>{{this.mode == "edit" ? "Cập nhật tài khoản" : "Tạo tài khoản"}}</span>&nbsp;&nbsp;
				<i class="fa fa-save"></i>
			</span>
		</a>
		<a href="javascript:;" @click.prevent="goBack" style="float:right; margin-right: 25px;background-color: #949494;border-color: #949494;" class="btn btn-success m-btn m-btn--custom m-btn--icon">
			<span>
				<span>Thoát</span>&nbsp;&nbsp;
				<i class="fa fa-sign-out"></i>
			</span>
		</a>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { Utilities } from "../../utilities";
	import ClassSelection from '../ClassSelection';
	import DataTable from "../DataTable";
	import CurrencyInput from "../CurrencyInput";
	import AccountConfigForm from "./AccountConfigForm";

	export default {
		data(){
			return {
				"mode": "create",
				"parentsCode": [],
				"expires_opts": {
					0: "--Mức gia hạn--",
					"trial": "Trial (10 ngày)",
					1: "1 tháng",
					3: "3 tháng (+1)",
					6: "6 tháng (+2)",
					9: "9 tháng (+4)",
					12: "12 tháng (+6)"
				},

				"expires_time": -1,
				"expires_at": "",
				"orig_expires_at": "",
				"currentSelectedBudget": {},

				"role": "",
				"password": "",
				"confirm_password": "",
				"fullName": "",
				"note": "",
				"budget": "",
				"allow_bet": false,
				"ki": false,
				"currentClass": 0,

				"partner_uid": "",
				"partner_uname": "",
				"connectSuccess": false,
				"partner_status": "create",

				"editUserCode": "",
				"editUserId": "",
				"editUserClass": {}
			}
		},

	    created() {
	    	this.role = this.$route.params.code ? Utilities.getRole(this.$route.params.code) : this.$route.params.role;
			if(this.role != 'house' && this.role != 'admin'){
				this.fetchParentsCode(this.role);
			}

			if(this.$route.params.code){
				this.mode = "edit";
				this.partner_status = "update";
				this.connectSuccess = true;
				this.fetchUserInfo(this.$route.params.code);
				this.fetchUserBudget(this.$route.params.code);
			}

			if(this.user.role == "admin" || this.user.username == "administrator" || this.user.code == ""){
				this.currentSelectedBudget = this.userBudget;
			}

			if(this.mode == "create" && this.role != "player"){
				this.connectSuccess = true;
			}
		},

	    mounted() {
			let vm = this;
			this.expires_time = this.mode == "edit" ? 0 : "trial";
			$("#create-acc-group").attr("disabled", "true");

			$(".code").select2({width: '100%'});
			this.initParentCodeEvent();
		},

	    components: {
			'account-config': AccountConfigForm,
			'he-selection': ClassSelection,
			'currency-input': CurrencyInput
		},

		watch: {
			parentsCode: function(val){
				let vm = this;
				if(val.length > 0){
					let options = [];

					for(let i=0;i<val.length;i++){
						if(this.mode == "create" && i==0){
							this.currentClass = val[i].class[Object.keys(val[i].class)[0]];
						}

						let option = new Option(val[i].code.toUpperCase(), val[i].code, false, false);
						options.push(option);
					}

					this.$nextTick(()=>{
						for(let i=0;i<options.length;i++){
							$("#parentCode").append(options[i]).trigger('change');
						}
						$(".code").select2();
						vm.initParentCodeEvent();

						$("#codeCharacter1").val(vm.editUserCode[vm.editUserCode.length-2]);
						$("#codeCharacter2").val(vm.editUserCode[vm.editUserCode.length-1]);
						$('#codeCharacter1').trigger('change');
						$('#codeCharacter2').trigger('change');

						if(vm.$route.params.currentCode || vm.$route.params.code) vm.tryToBindParent();
    				});
					
					
				}
			},
			expires_time: function(val){
				if(val == "trial" && this.mode == "create"){
					this.expires_at = moment().add(10, 'days').format('DD/MM/YYYY');
					return;
				}

				let life = parseInt(val) + Utilities.getBonus(val);
				if(this.mode == "create"){
					this.expires_at = moment().add(life, 'M').format('DD/MM/YYYY');
				}else{
					let exp = moment(this.orig_expires_at, "YYYY/MM/DD HH:mm:ss");
					let expired = exp.diff(moment(), "s") <= 0;
					this.expires_at = (expired ? moment().add(life, 'M') : exp.add(life, 'M')).format('DD/MM/YYYY');
				}
			},
			editUserCode: function(val){
				this.$nextTick(()=>{
					if(this.role == "house"){
						$("#codeCharacter1").val(val);
						$('#codeCharacter1').trigger('change');
					}else{
						$("#codeCharacter1").val(val[val.length-2]);
						$("#codeCharacter2").val(val[val.length-1]);
						$("#parentCode").val(val.substr(0, val.length-2));
						$('#codeCharacter1').trigger('change');
						$('#codeCharacter2').trigger('change');
						$('#parentCode').trigger('change');
					}
				});
			}
		},

	    computed: {
			...mapGetters({
				user: 'user',
		  		userBudget: 'userBudget'
			}),
			codeCharacters: function(){
				let arr = [];
				for(let i=48;i<=90;i++){
					if(i>=58 && i<=64) continue;
					arr.push(String.fromCharCode(i));
				}

				return arr;
			},
			remainBudget: function(){
				let parentCode = $("#parentCode").val();
				parentCode = parentCode ? parentCode : this.user.username;
				return parentCode + ": "+Utilities.currencyFormat(this.currentSelectedBudget.remain);
			},
			expiresColor: function(){
				let exp = moment(this.expires_at, "DD/MM/YYYY");
				let expired = exp.diff(moment(), "s") <= 0;

				return expired ? "color:red;" : "";
			}
		},

		methods:{
			connectPlayer: function(){
				let vm = this;
				this.fullName = "";
				
				if(this.partner_uname == ""){
					swal("", "Vui lòng nhập Tên đăng nhập!", "error");
					return;
				}

				if(this.validateContainSpecialCharacter(this.partner_uname)){
					swal("Tên đăng nhập không hợp lệ!", "Tên đăng nhập chỉ bao gồm các ký tự từ a->z, các số từ 0->9", "error");
                	return;
				}

				if(this.partner_uname.length > 24){
					swal("Tên đăng nhập không hợp lệ!", "Tên đăng nhập không được vượt quá 24 ký tự", "error");
                	return;
				}

				axios.get("partner/connect/"+this.partner_uname)
					.then(res => {
						res = res.data;

						vm.partner_status = res.code == 0 ? "update" : "create";
						vm.connectSuccess = true;
						vm.fullName = res.data ? res.data.name : "";
						
						vm.fetchParentUserBudget($("#parentCode").val());
					});
			},

			initParentCodeEvent: function(){
				let vm = this;
				$("#parentCode").on('change', function (e) {
					let code = $(this).val();
				    vm.fetchParentUserBudget(code);
				    vm.$refs.config.loadUserConfig();

					if(vm.mode == "edit") return;

				    if(vm.$route.params.role == 'agency' || vm.$route.params.role == 'player'){
				    	let ps = vm.parentsCode;
				    	if(ps.length == 0) return;

						ps = ps.filter(x => {
							return x.code == code;
						});

						if(ps.length > 0){
							vm.currentClass = ps[0].class[Object.keys(ps[0].class)[0]];
						}
					}
				});
			},

			fetchParentUserBudget: async function(code = null){
				if(!code){
					this.currentSelectedBudget = this.userBudget;
					return;
				}

				let vm = this;
				this.fetchUserBudget(code, res => {
					vm.currentSelectedBudget = res.data;
				});
			},

			fetchUserBudget: function(code = null, cb = null){
				let vm = this;
				axios.get("admin-panel/user-info/budget/"+ code)
					.then(res => {
						res = res.data;
						if(cb) cb(res);
						else{
							if(this.mode == "edit"){
								vm.budget = res.data.budget;
							}
						}
					});
			},

			getPlayerCode: function(){
				let parentCode = $("#parentCode").length > 0 ? $("#parentCode").val() : "";
				let codeCharacter1 = $("#codeCharacter1").length > 0 ? $("#codeCharacter1").val() : "";
				let codeCharacter2 = $("#codeCharacter2").length > 0 ? $("#codeCharacter2").val() : "";
				let code = this.role == "player" ? parentCode : parentCode + codeCharacter1 + codeCharacter2;

				return code;
			},

			checkCode: function(){
				let code = this.getPlayerCode();
				
				if(code == ""){
					swal("", "Vui lòng chọn code cho tài khoản", "warning");
					return;
				}

				axios.get("admin-panel/user/check-available/"+ code)
					.then(res => {
						res = res.data;
						let mess = code + (res.data.available ?  " có thể sử dụng!" : " không thể sử dụng. Vui lòng chọn mã khác!");
						let status = res.data.available ? "success" : "error";
						swal("", mess, status);
					});
			},

			onExpiresChange: function(month){
				this.expires_time = month;
			},

			fetchParentsCode: function(role){
				let vm = this;

				axios.get("admin-panel/user/parents/"+ role)
					.then(res => {
						res = res.data;
						let parents = res.data;
						vm.parentsCode = parents;
					});
			},

			fetchUserInfo: function(code){
				let vm = this;

				axios.get("admin-panel/user-info?code="+ code)
					.then(function (response) {
						let res = response.data;
						if(res.code == 0){
			            	vm.fullName = res.data.fullname;
			            	vm.note = res.data.note;
			            	vm.currentClass = res.data.class[Object.keys(res.data.class)[0]];
			            	if(res.data.role == "player"){
			            		vm.allow_bet = res.data.allow_bet;
			            		vm.ki = res.data.ki == 1;
			            		vm.partner_uname = res.data.partner_user;
				            	vm.expires_at = moment(res.data.expires_at, "YYYY/MM/DD HH:mm:ss").format('DD/MM/YYYY');
				            	vm.orig_expires_at = res.data.expires_at;
			            	}
			            	
			            	if(vm.mode == "edit"){
			            		vm.editUserId = res.data.id;
				            	vm.editUserCode = res.data.code;
				            	vm.editUserClass = res.data.class;
				            	vm.passConfigToParent({uid: res.data.id, code: res.data.code, class: res.data.class});
			            	}
		            	}
					});
			},

			passConfigToParent: function(config){
				this.$emit("edit-user-change", config);
			},

			createAccount: function(){
				let code = this.getPlayerCode();
				
				if(code == ""){
					swal("", "Vui lòng chọn code cho tài khoản", "warning");
					return;
				}

				//no need to validate password for 
				// - edit mode
				// - create player with exist partner => mode = update
				if((this.mode == "create" && this.$route.params.role != "player") || (this.partner_status == "create" && this.$route.params.role == "player")){
					if(this.password == "") { 
						swal("", "*Mật khẩu không được để trống!", "error");
						return;
					}
					
					if(this.confirm_password == "") { 
						swal("", "*Nhập lại mật khẩu không được để trống!", "error");
						return;
					}

					if(this.password !== this.confirm_password){
						swal("", "Mật khẩu và mật khẩu nhập lại không khớp nhau!", "error");
						return;
					}
				}

				let url = this.mode == "create" ? "admin-panel/user/create/" + this.role : "admin-panel/user/edit/" + this.role + "/" + this.$route.params.code;

				let data = {
					code: code, password: this.password,
					note: this.note, fullName: this.fullName,
					budget: this.budget
				};

				if(this.role == "player"){
					if(this.mode == "create"){
						if(this.validateContainSpecialCharacter(this.partner_uname)){
							swal("Tên đăng nhập không hợp lệ!", "Tên đăng nhập chỉ bao gồm các ký tự từ a->z, các số từ 0->9", "error");
	                    	return;
						}

						if(this.partner_uname.length > 24){
							swal("Tên đăng nhập không hợp lệ!", "Tên đăng nhập không được vượt quá 24 ký tự", "error");
	                    	return;
						}
					}

					data.partner_mode = this.partner_status;
					data.partner_user = this.partner_uname;
					data.month = this.expires_time;
					data.allow_bet = this.allow_bet;
					data.ki = this.ki == true ? 1 : 0;
					data.class = this.currentClass;
					data.agent = code;
				}

				let vm = this;

				mApp.blockPage({
				    overlayColor: '#000000',
				    type: 'loader',
				    state: 'primary',
				    message: 'Đang xử lý...'
				});

				axios.post(url, data)
					.then((res) => {
						mApp.unblockPage();
						res = res.data;
						if(res.code == 0){
			            	vm.editUserId = res.data.uid;
			            	vm.editUserCode = res.data.code;
			            	vm.editUserClass = res.data.class;
			            	vm.passConfigToParent({uid: res.data.uid, code: res.data.code, class: res.data.class});
			            	vm.toastMessage("success", "Lưu thông tin tài khoản "+res.data.code+" thành công!");
			            	vm.updateGameConfig(res.data.code);

			            	vm.$router.go(-1);
			            }
					}).catch(function (error) {
						mApp.unblockPage();
						console.log(error);
					});
			},

			validateContainSpecialCharacter: function(uname){
                let reg= /^[a-z0-9]+$/;
                return !reg.test(uname);
            },

			updateGameConfig: function(code){
				let limitedChange = this.$refs.config.getValueChange(".value_limit_day input", "limit_day");

				let heCommissionChange = this.$refs.config.getValueChange(".commission input");
				let heRateChange = this.$refs.config.getValueChange(".rate input");
				let heChange = this.mergeHeChange(heCommissionChange, heRateChange);

				if(limitedChange.length == 0 && heChange.length == 0) return;

				let data = {
					"limit": limitedChange,
					"heChange": heChange
				};

				if(code == 'admin'){
					let limitedOnceChange = this.$refs.config.getValueChange(".value_limit_once input", "limit_once");
					limitedOnceChange = this.mergelimitChange(limitedChange, limitedOnceChange);
					if(limitedOnceChange.length > 0){
						data.limit = limitedOnceChange;
					}
				}

				let vm = this;
				
				mApp.blockPage({
				    overlayColor: '#000000',
				    type: 'loader',
				    state: 'primary',
				    message: 'Đang xử lý...'
				});

				axios.put("admin-panel/config/update/"+code, data)
					.then((res) => {
						mApp.unblockPage();
						res = res.data;
						vm.toastMessage("success", "Lưu cấu hình tài khoản "+code+" thành công!");
					}).catch(function (error) {
						mApp.unblockPage();
						console.log(error);
					});
			},

			mergeHeChange: function(coms, rates){
				let merge = {};

				for (var i = 0; i < coms.length; i++) {
					let keys = coms[i].class+"_"+coms[i].gameId+"_"+coms[i].propId;
					if(!merge[keys]) merge[keys] = coms[i];
				}

				for (var i = 0; i < rates.length; i++) {
					let keys = rates[i].class+"_"+rates[i].gameId+"_"+rates[i].propId;
					if(!merge[keys]) merge[keys] = rates[i];
					merge[keys]["rate"] = rates[i]["rate"];
				}

				merge = Object.values(merge);
				for (var i = 0; i < merge.length; i++) {
					if(!merge[i]["rate"]){
						merge[i]["rate"] = parseInt($(".rate input[gameid="+merge[i]["gameId"]+"][propid="+merge[i]["propId"]+"]").val());
					}
					if(!merge[i]["commission"]){
						merge[i]["commission"] = parseInt($(".commission input[gameid="+merge[i]["gameId"]+"][propid="+merge[i]["propId"]+"]").val());
					}
				}

				return merge;
			},

			mergelimitChange: function(limitDay, limitOnce){
				let merge = {};

				for (var i = 0; i < limitDay.length; i++) {
					let keys = limitDay[i].gameId+"_"+limitDay[i].propId;
					if(!merge[keys]) merge[keys] = limitDay[i];
				}

				for (var i = 0; i < limitOnce.length; i++) {
					let keys = limitOnce[i].gameId+"_"+limitOnce[i].propId;
					if(!merge[keys]) merge[keys] = limitOnce[i];
					merge[keys]["limit_once"] = limitOnce[i]["limit_once"];
				}

				merge = Object.values(merge);
				// for (var i = 0; i < merge.length; i++) {
				// 	if(!merge[i]["limit_once"]){
				// 		merge[i]["limit_once"] = parseInt($(".rate input[gameid="+merge[i]["gameId"]+"][propid="+merge[i]["propId"]+"]").val());
				// 	}
				// 	if(!merge[i]["commission"]){
				// 		merge[i]["commission"] = parseInt($(".commission input[gameid="+merge[i]["gameId"]+"][propid="+merge[i]["propId"]+"]").val());
				// 	}
				// }

				return merge;
			},

			toastMessage: function(type, message){
				toastr.options = {
				  "closeButton": false,
				  "debug": false,
				  "newestOnTop": false,
				  "progressBar": false,
				  "positionClass": "toast-bottom-right",
				  "preventDuplicates": false,
				  "onclick": null,
				  "showDuration": "300",
				  "hideDuration": "1000",
				  "timeOut": "5000",
				  "extendedTimeOut": "1000",
				  "showEasing": "swing",
				  "hideEasing": "linear",
				  "showMethod": "fadeIn",
				  "hideMethod": "fadeOut"
				};

				if(type == "error"){
					toastr.error(message);
				}else{
					toastr.success(message);
				}
			},

			tryToBindParent: function(){
				let code = this.$route.params.code;
				if(!code) code = this.$route.params.currentCode;
				let role = this.role;

				let len = 9;
				switch(role){
					case 'player': len = 7; break;
					case 'agency': len = 5; break;
					case 'general': len = 3; break;
					case 'company': len = 1; break;
				}

				code = code.substr(0, len);
				let pcode = "";

				for(let i=0; i<this.parentsCode.length; i++){
					let c = this.parentsCode[i];
					if(c.code.indexOf(code) >= 0){
						pcode = c.code;
						break;
					}
				}

				if(pcode == ""){
					pcode = this.parentsCode[0].code;
				}

				$("#parentCode").val(pcode);
        		$('#parentCode').trigger('change');
			},

			onHeChange: function(val){
				this.currentClass = val;
				this.$refs.config.loadUserConfig(null, val);
			},

			goBack: function(){
				this.$router.go(-1);
			}
		}
	}
</script>

<style>
	.col-form-label{
	    padding-right: 0px;
	    padding-left: 10px;
	}
	.m-accordion__item{
		cursor: pointer;
	}
	.no-parent{
		font-size: 18px;
	    font-style: italic;
	    padding: 20px;
	}
</style>